import { BaseModel } from 'sjs-base-model';

export default class FileExistModel extends BaseModel {

    constructor(data) {
        super();
        this.exists = false;
        this.update(data);
    }
}